import React from 'react';
import CacheUpdateManager from './CacheUpdateManager';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <a 
          href="https://lighthouse.hudsonriggs.systems" 
          target="_blank" 
          rel="noopener noreferrer"
          className="footer-link"
        >
          <img 
            src="/lighthouse_logo.svg" 
            alt="Lighthouse" 
            className="footer-logo"
          />
          <span className="footer-text">
            © Light House
          </span>
        </a>
        
        <span className="footer-separator">-</span>
        
        <a 
          href="https://hudsonriggs.systems" 
          target="_blank" 
          rel="noopener noreferrer"
          className="footer-link"
        >
          <img 
            src="/hrsys_logo.svg" 
            alt="HudsonRiggs.Systems" 
            className="footer-logo"
          />
          <span className="footer-text">
            A HudsonRiggs.Systems Product
          </span>
        </a>
        
        <span className="footer-separator">-</span>
        
        <CacheUpdateManager showAsButton={true} className="footer-cache-btn" />
      </div>
    </footer>
  );
};

export default Footer; 